// extracted by mini-css-extract-plugin
export default {"error-page":"error_error-page__zRLAJ"};